import { Button, Popover, SegmentedControl } from "@blueprintjs/core";
import { IconNames } from "@blueprintjs/icons";
import { FieldLabel } from "components/common/FieldLabel";
import css from "./ToggleFilterSelect.module.scss";

const DROPDOWN_OFFSET = 8;

export const TOGGLE_ALL = "";

export interface ToggleFilterField {
    readonly key: string;
    readonly label: string;
    readonly options: ReadonlyArray<{
        readonly value: string;
        readonly label: string;
    }>;
    readonly value: string;
    readonly onChange: (value: string) => void;
}

export const ToggleFilterSelect: React.FC<{
    label: string;
    fields: ReadonlyArray<ToggleFilterField>;
}> = ({ label, fields }) => {
    const narrowedCount = fields.filter(
        (field) => field.value !== TOGGLE_ALL
    ).length;

    const popoverContent = (
        <div className={css["ToggleFilterSelect-popover"]}>
            <div className={css["ToggleFilterSelect-popover-header"]}>
                <span className={css["ToggleFilterSelect-popover-title"]}>
                    {label}
                </span>
                <Button
                    variant="minimal"
                    size="small"
                    intent="primary"
                    disabled={narrowedCount === 0}
                    onClick={() =>
                        fields.forEach((field) => field.onChange(TOGGLE_ALL))
                    }
                >
                    Reset
                </Button>
            </div>
            {fields.map((field) => (
                <div
                    key={field.key}
                    className={css["ToggleFilterSelect-popover-field"]}
                >
                    <FieldLabel>{field.label}</FieldLabel>
                    <SegmentedControl
                        small
                        fill
                        value={field.value}
                        onValueChange={field.onChange}
                        options={[
                            { label: "All", value: TOGGLE_ALL },
                            ...field.options
                        ]}
                    />
                </div>
            ))}
        </div>
    );

    return (
        <Popover
            content={popoverContent}
            placement="bottom-start"
            popoverClassName={css["ToggleFilterSelect-dropdown"]}
            modifiers={{
                offset: {
                    enabled: true,
                    options: { offset: [0, DROPDOWN_OFFSET] }
                }
            }}
            minimal
        >
            <Button
                className={css["ToggleFilterSelect-button"]}
                endIcon={IconNames.CHEVRON_DOWN}
                intent={narrowedCount > 0 ? "primary" : "none"}
                variant="outlined"
            >
                {label}
                <span
                    className={css["ToggleFilterSelect-badge"]}
                    style={{
                        visibility: narrowedCount > 0 ? "visible" : "hidden"
                    }}
                >
                    {narrowedCount}
                </span>
            </Button>
        </Popover>
    );
};
